import { useEffect, useState } from "react";
import {
  prefersReducedMotion,
  REDUCED_MOTION_QUERY,
} from "@/lib/reveal-motion";

/** The OS reduced-motion preference, followed while mounted. */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    const query = window.matchMedia?.(REDUCED_MOTION_QUERY);
    if (!query?.addEventListener) return;
    const update = () => setReduced(query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return reduced;
}
